import { MAIL_DEEPLINK_URL_BASE, MAIL_READ_ROUTE, GROUP_READ_ROUTE } from './deeplinkConstants';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { formatUrl } from 'owa-popout/lib/utils/formatUrl';

export function getMailReadDeeplink(itemId: string): string {
    return itemId
        ? formatUrl(
              MAIL_DEEPLINK_URL_BASE,
              MAIL_READ_ROUTE + '/' + encodeURIComponent(itemId),
              getHostLocation().search
          )
        : '';
}

export function getMailReadDeeplinkForGroupMailbox(itemId: string, groupMailboxId: string): string {
    if (itemId && groupMailboxId && groupMailboxId.indexOf('@') > 0) {
        const emailAddressParts = groupMailboxId.split('@');
        const route =
            MAIL_READ_ROUTE +
            '/' +
            encodeURIComponent(itemId) +
            '/' +
            GROUP_READ_ROUTE +
            `/${emailAddressParts[1]}/${emailAddressParts[0]}`;
        return formatUrl(MAIL_DEEPLINK_URL_BASE, route, getHostLocation().search);
    } else {
        return '';
    }
}
